
function supportsAudio(): boolean {
  return !!document.createElement('audio').canPlayType;
}

async function fetchAudioDuration(url: string): Promise<number | null> {
  return new Promise((resolve) => {
    const audioElement = document.createElement('audio');
    audioElement.preload = 'metadata';
    audioElement.src = url;

    audioElement.onloadedmetadata = () => {
      resolve(audioElement.duration);
    };

    audioElement.onerror = () => {
      resolve(null); // 或者抛出错误
    };
  });
}

/**
 * 获取多个音频文件的总播放时间长度。
 * 
 * @param audioUrls - 音频文件的 URL 数组。
 * @returns 一个 Promise，解析为总播放时间长度。
 */
export async function getTotalAudioDuration(audioUrls: string[]): Promise<number> {
  if (!supportsAudio()) {
    console.warn('Audio element is not supported by this browser.');
    return 0;
  }

  if (!audioUrls || !audioUrls.length) {
    return 0;
  }

  let total = 0;
  try {
    const durations = await Promise.all(audioUrls.map(async (url) => {
      const duration = await fetchAudioDuration(url);
      return duration || 0;
    }));

    total = durations.reduce((acc, curr) => acc + curr, 0);
  } catch (error) {
    console.error('Failed to fetch audio durations:', error);
  }

  console.log('[Origin]', total);
  return total;
}